import './botao.css'

const Botao = (props) => {
    return(
        <button>{props.children}</button>
    )
}
export default Botao;